interface Props {
  iconName: string
  size?: 'tiny' | 'small' | 'medium' | 'large'
  title?: string
  className?: string
  category?: number
}

const BlizzardIcon = ({
  iconName,
  size,
  title,
  className,
  category = 36,
}: Props) => {
  const sizeStyles = {
    tiny: 'w-3 h-3 border-0',
    small: 'w-4 h-4 border-0',
    medium: 'w-6 h-6 border',
    large: 'w-8 h-8 border-2',
  }[size ?? 'medium']

  const iconStyles = `${sizeStyles} border-[#666] rounded-md ${className ?? ''}`

  return (
    <img
      className={iconStyles}
      title={title}
      alt={title}
      src={`https://render.worldofwarcraft.com/us/icons/${category}/${iconName}.jpg`}
    />
  )
}

export default BlizzardIcon
